import React, { useEffect, useState, useContext } from "react";
import MenuProvideradmin from "./navProvideradmin/MenuProvideradmin";
import * as publicApi from "../../service/publicApi";
import Map from "../material/map/Map";
import { CurrentUserContext } from "../../App";
import Select from "../material/select/Select";
import styles from "./styleProvider.module.css";
import Button from "../material/button/Button";
import { useNavigate } from "react-router-dom";

import DataTable from "react-data-table-component";
import MenuLegged from "../header/Menu";
// import Breadcrumb from "../breadcrumb/breadcrumb";
import Breadcrumb from "../public/breacrumb/breadcrumb";

import { FaFileAlt, FaUser, FaUsers } from "react-icons/fa";
import Footer from "../footer/Footer";

const customStyles = {
  rows: {
    style: {
      // override the row height
      "&:nth-child(even)": {
        background: "#f7f7f7",
      },
      "&:not(:last-of-type)": {
        borderBottomWidth: "none",
      },
    },
  },
  headCells: {
    style: {
      // override the cell padding for head cells
      display: "flex",
      justifyContent: "center",
      background: "#f7f7f7",
      fontSize: 18,
      "@media (max-width: 800px)": {
        fontSize: 14,
      },
    },
  },
  cells: {
    style: {
      // override the cell padding for data cells
      display: "flex",
      justifyContent: "center",
      borber: "1px solid #B8DFC7",
    },
  },
};

function InspectionRateMap() {
  const { setIsMessage } = useContext(CurrentUserContext);
  const navigate = useNavigate();

  const [healthArea, setHealthArea] = useState("");
  const [healthAreaList, setHealthAreaList] = useState([
    {
      key: "1",
      value: "เขตสุขภาพที่ 1",
    },
    {
      key: "2",
      value: "เขตสุขภาพที่ 2",
    },
    {
      key: "3",
      value: "เขตสุขภาพที่ 3",
    },
    {
      key: "4",
      value: "เขตสุขภาพที่ 4",
    },
    {
      key: "5",
      value: "เขตสุขภาพที่ 5",
    },
    {
      key: "6",
      value: "เขตสุขภาพที่ 6",
    },
    {
      key: "7",
      value: "เขตสุขภาพที่ 7",
    },
    {
      key: "8",
      value: "เขตสุขภาพที่ 8",
    },
    {
      key: "9",
      value: "เขตสุขภาพที่ 9",
    },
    {
      key: "10",
      value: "เขตสุขภาพที่ 10",
    },
    {
      key: "11",
      value: "เขตสุขภาพที่ 11",
    },
    {
      key: "12",
      value: "เขตสุขภาพที่ 12",
    },
    {
      key: "13",
      value: "เขตสุขภาพที่ 13",
    },
  ]);

  const [province, setProvince] = useState("");
  const [provinceList, setProvinceList] = useState([]);
  const [optionProvince, setOptionProvince] = useState([]);

  const [district, setDistrict] = useState("");
  const [districtList, setDistrictList] = useState([]);
  const [optionDistrict, setOptionDistrict] = useState([]);

  const [labList, setLabList] = useState([]);
  const [labListSelct, setLabListSelect] = useState([]);

  const [labListAll, setLabListAll] = useState([]);

  const [longitude, setLongitude] = useState(100.531792);
  const [latitude, setLatitude] = useState(13.853135);
  const [selectValueOption, setSelectValueOption] = useState(null);
  const [nameLocationMap, setNameLocationMap] = useState(
    "88/7 ซอยบำราศนราดูร ถ.ติวานนท์ ต.ตลาดขวัญ อ.เมือง จ.นนทบุรี 11000",
  );

  useEffect(() => {
    getLabList();
  }, []);

  useEffect(() => {
    getProvince();
  }, [healthArea]);

  useEffect(() => {
    getDistrict();
  }, [province]);

  useEffect(() => {
    getLaboratoryList();
  }, [healthArea, province, district]);

  const getLabList = async () => {
    let res = await publicApi.getLaboratoryList();
    if (res) {
      if (res["data"]["code"] === 200) {
        setLabListAll(res["data"]["laboratory_list"]);
        setLabList(
          res["data"]["laboratory_list"].map((item) => {
            return {
              key: item["laboratory_id"],
              value: item["laboratory_name"],
              current_address: item["current_address"],
              location: {
                lat: item["location"]["latitude"],
                long: item["location"]["longitude"],
              },
            };
          }),
        );
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getProvince = () => {
    let List = [];
    List.push(
      labListAll.map((item) => {
        return {
          health_area: item["current_address"]["health_area"],
          province_id: item["current_address"]["province_id"],
          province_name: item["current_address"]["province_name"],
        };
      }),
    );

    for (let i = 0; i < List[0].length; i++) {
      if (List[0][i]["health_area"] === healthArea) {
        provinceList.push(List[0][i]);
      }
    }

    //กรองชื่อซ้ำ
    let newArray = [];
    let uniqueObject = {};

    for (let i in provinceList) {
      let objTitle = provinceList[i]["province_id"];
      uniqueObject[objTitle] = provinceList[i];
    }

    for (let i in uniqueObject) {
      newArray.push(uniqueObject[i]);
    }

    setProvinceList(
      newArray.map((i) => {
        return {
          key: i["province_id"],
          value: i["province_name"],
        };
      }),
    );
  };

  const getDistrict = () => {
    let List = [];
    List.push(
      labListAll.map((item) => {
        return {
          province_id: item["current_address"]["province_id"],
          district_id: item["current_address"]["district_id"],
          district_name: item["current_address"]["district_name"],
        };
      }),
    );

    for (let i = 0; i < List[0].length; i++) {
      if (List[0][i]["province_id"] === province) {
        districtList.push(List[0][i]);
      }
    }

    //กรองชื่อซ้ำ
    let newArray = [];
    let uniqueObject = {};

    for (let i in districtList) {
      let objTitle = districtList[i]["district_id"];
      uniqueObject[objTitle] = districtList[i];
    }

    for (let i in uniqueObject) {
      newArray.push(uniqueObject[i]);
    }

    setDistrictList(
      newArray.map((i) => {
        return {
          key: i["district_id"],
          value: i["district_name"],
        };
      }),
    );
  };

  const getLaboratoryList = () => {
    if (healthArea && !province && !district) {
      let lablist = [];
      for (let i = 0; i < labList.length; i++) {
        if (labList[i]["current_address"]?.["health_area"] === healthArea) {
          lablist.push(labList[i]);
        }
      }
      setLabListSelect(lablist);
    } else if (healthArea && province && !district) {
      let lablist = [];
      for (let i = 0; i < labList.length; i++) {
        if (labList[i]["current_address"]?.["province_id"] === province) {
          lablist.push(labList[i]);
        }
      }
      setLabListSelect(lablist);
    } else if (healthArea && province && district) {
      let lablist = [];
      for (let i = 0; i < labList.length; i++) {
        if (labList[i]["current_address"]?.["district_id"] === district) {
          lablist.push(labList[i]);
        }
      }
      setLabListSelect(lablist);
    }
  };

  const handleChange = (event) => {
    setSelectValueOption(event);
    // console.log(event)

    let selectMap = [];
    for (let i = 0; i < labList.length; i++) {
      if (labList[i]["key"] === event) {
        selectMap.push(labList[i]);
      }
    }

    setNameLocationMap(
      selectMap[0].laboratory_name +
        " " +
        "ที่อยู่ " +
        selectMap[0].current_address.address +
        " " +
        "หมู่ " +
        selectMap[0].current_address.village_number +
        " " +
        "ซอย" +
        selectMap[0].current_address.alley +
        " " +
        "ถ." +
        selectMap[0].current_address.road +
        " " +
        "ต." +
        selectMap[0].current_address.sub_district_name +
        " " +
        "อ." +
        selectMap[0].current_address.district_name +
        " " +
        "จ." +
        selectMap[0].current_address.province_name +
        " " +
        selectMap[0].current_address.post_code,
    );
    setLongitude(selectMap[0].location.long);
    setLatitude(selectMap[0].location.lat);
  };

  const onClickButton = () => {
    window.open(
      `https://maps.google.com/?q=${latitude},${longitude}`,
      "_system",
    );
  };

  const columnsListAll = [
    {
      name: "ลำดับ",
      selector: (i, idx) => <div>{idx + 1}</div>,
      width: "20%",
    },
    {
      name: "รายชื่อห้องปฏิบัติการในระบบ",
      selector: (i) => <div>{i["laboratory_name"]}</div>,
      wrap: true,
    },
  ];

  const columnsListSelect = [
    {
      name: "ลำดับ",
      selector: (i, idx) => <div>{idx + 1}</div>,
      width: "20%",
    },
    {
      name: "รายชื่อห้องปฏิบัติการในระบบ",
      selector: (i) => <div>{i["value"]}</div>,
      wrap: true,
    },
  ];

  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "ผลสรุป", url: "/manager/aggregateResult" },
    { name: "แผนที่ห้องปฏิบัติการที่มีในระบบ", url: "" },
  ];

  return (
    <div className={styles.page}>
      {/* <MenuLegged
        menuActive={"aggregateResult"}
        submenuActive={"maplocation"}
      /> */}

      <div className="mt-[10px]">
        <Breadcrumb pathItems={pathItems} />
      </div>
      <div className={styles.sidepage}>
        <p className="text-center text-2xl font-bold lg:!mt-[20px] mt-[70px] md:mt-2 font-['Prompt-SemiBold']">
          ผลสรุป
        </p>

        <div className={styles.menuTab}>
          <div
            className={styles.tab}
            onClick={(e) => navigate("/manager/aggregateResult")}
          >
            สรุปจำนวนการเข้าใช้งาน
          </div>
          <div
            className={styles.tab}
            onClick={(e) => navigate("/manager/geneResult")}
          >
            สรุปผลการตรวจยีนทั้งหมด
          </div>
          <div className={styles.tabActive}>
            แผนที่ห้องปฏิบัติการที่มีในระบบ
          </div>
        </div>

        <p className="text-left text-2xl font-bold my-4 font-['Prompt-SemiBold']">
          แผนที่ห้องปฏิบัติการที่มีข้อมูลในระบบ
        </p>
        <div className="justify-center mt-16">
          {/* <p className="text-center text-[#FF9768] text-2xl underline underline-offset-2 font-bold mt-8">
          แผนที่ห้องปฏิบัติการที่มีข้อมูลในระบบ
        </p> */}
          <div className={styles.select}>
            <Select
              placeholder="เลือกเขตสุขภาพ"
              label="เลือกเขตสุขภาพ"
              value={healthArea}
              setValue={(e) => {
                setHealthArea(e);
                setProvince("");
                setProvinceList([]);
                setDistrict("");
                setDistrictList([]);
                setLabListSelect([]);
                setSelectValueOption(null);
              }}
              list={healthAreaList}
              style={{ borderRadius: "5px" }}
            ></Select>

            <Select
              placeholder="เลือกจังหวัด"
              label="เลือกจังหวัด"
              value={province}
              disabled={healthArea === "" ? true : false}
              setValue={(e) => {
                setProvince(e);
                setDistrict("");
                setDistrictList([]);
                setLabListSelect([]);
                setSelectValueOption(null);
              }}
              list={provinceList}
              style={{ borderRadius: "5px" }}
            ></Select>

            <Select
              placeholder="เลือกอำเภอ"
              label="เลือกอำเภอ"
              value={district}
              disabled={province === "" ? true : false}
              setValue={(e) => {
                setDistrict(e);
                setLabListSelect([]);
                setSelectValueOption(null);
              }}
              list={districtList}
              style={{ borderRadius: "5px" }}
            ></Select>

            <Select
              placeholder="เลือกห้องปฏิบัติการที่เปิดตรวจ"
              label="เลือกห้องปฏิบัติการที่เปิดตรวจ"
              value={selectValueOption}
              setValue={handleChange}
              list={healthArea || province || district ? labListSelct : labList}
              style={{ borderRadius: "5px" }}
            ></Select>
          </div>
        </div>

        <div className={styles.tableMap}>
          <div className="pb-4" style={{ height: "400px" }}>
            <Map
              disabled={true}
              latitude={latitude}
              longitude={longitude}
              nameLab={nameLocationMap}
              onChange={(e) => {}}
            />
            {/* <Button
              disabled={selectValueOption ? null : true}
              style={{ margin: "auto", width: 200, marginTop: 15 }}
              onClick={() => {
                onClickButton();
              }}
            >
              ขอเส้นทาง
            </Button> */}
          </div>

          <p className="text-left text-2xl font-bold my-4 font-['Prompt-SemiBold']">
            แผนที่ห้องปฏิบัติการที่มีข้อมูลในระบบ
          </p>
          <div className="flex flex-wrap justify-start bg-[#fff]">
            {healthArea === "" ? (
              <>
                {labListAll.map((item) => (
                  <div className="w-1/2 p-2 border">{item.laboratory_name}</div>
                ))}
              </>
            ) : (
              <>
                {labListSelct.length > 0 ? (
                  labListSelct.map((item) => (
                    <div className="w-1/2 p-2 border">{item.value}</div>
                  ))
                ) : (
                  <>ไม่พบข้อมูล</>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default InspectionRateMap;
